import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  useDeleteDepartmentMutation,
  useGetDepartmentsListQuery,
} from "../../../store/departments/DepartmentsApiSlice";
import CustomIconBox from "../../../theme/style-components/CustomIconBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomButton from "../../../theme/style-components/CustomButton";
import CustomModal from "../../../theme/style-components/CustomModal";
import AddEntryModal from "../AddDepartmentAndTeam";
import { Height } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectCurrentUserObject } from "../../../store/auth/authSlice";

const Departments = () => {
  const userType = localStorage.getItem("userType");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const user = useSelector(selectCurrentUserObject);
  const [deleteDepartment] = useDeleteDepartmentMutation();
  const {
    isLoading: isDepartmentsLoading,
    data: DepartmentsData,
    error: isDepartmentsError,
    refetch: refetchDepartmentsData,
  } = useGetDepartmentsListQuery({
    org_id: user?.company,
  },{skip: !user?.company});

  const handleDeleteDepartment = async () => {
    console.log("I am going to delete");
    try {
      const result = await deleteDepartment(selectedDepartment.id)
        .unwrap()
        .then((res) => {
          console.log(res, "res");
          toast.success("Department deleted successfully");
          // Reset and close modal
          refetchDepartmentsData();
          setIsDeleteModalOpen(false);
        });
    } catch (error) {
      toast.error(`Something went wrong!!`);
    }
  };

  return (
    <>
      <Box sx={{ display: "grid", gap: "15px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "15px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" align="center" sx={{ fontSize: "18px" }}>
            Departments
          </Typography>
          {userType === "ADMIN" && (
            <Button
              type="button"
              color="primary"
              sx={{
                p: "8px 15px",
                background: "#1F6EB9",
                color: "#fff",
                lineHeight: "1",
                fontSize: "14px",
                fontWeight: "500",
                "&:hover": {
                  background: "#388edf",
                },
              }}
              onClick={() => {
                console.log("Add button clicked");
                setIsModalOpen(true);
              }}
            >
              {" "}
              + Add
            </Button>
          )}
        </Box>
        <Box>
          {isDepartmentsLoading ? (
            <Typography variant="h6" align="center">
              Loading...
            </Typography>
          ) : (
            <Typography
              variant="h6"
              sx={{ border: "1px solid #dfe3e8", borderTop: 0 }}
            >
              {DepartmentsData?.data.map((department) => (
                <Box
                  key={department.id}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    alignItems: "center",
                    borderTop: "1px solid #dfe3e8",
                    padding: "10px 15px",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      m: 0,
                      p: 0,
                      lineHeight: "1",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    key={department.id}
                  >
                    {department.name}
                  </Typography>
                  {/* <Typography variant="p" sx={{ m: 0, p: 0, lineHeight: "1", fontSize:'15px' }}>
                  {department.description}
                </Typography> */}
                  {userType === "ADMIN" && (
                    <Box sx={{ display: "flex", gap: "10px", m: "0" }}>
                      <EditIcon
                        sx={{ width: "22px" }}
                        onClick={() => {
                          setSelectedDepartment(department);
                          setIsEditModalOpen(true);
                        }}
                      />
                      <DeleteIcon
                        sx={{ width: "22px" }}
                        onClick={() => {
                          setSelectedDepartment(department);
                          setIsDeleteModalOpen(true);
                        }}
                      />
                    </Box>
                  )}
                </Box>
              ))}
            </Typography>
          )}
        </Box>
      </Box>

      <CustomModal
        isModalOpen={isModalOpen}
        isShowActionButton= {false}
        handleClose={() => setIsModalOpen(false)}
        title={`Add Department`}
      >
        <AddEntryModal
          onClose={() => setIsModalOpen(false)}
          title={`Department`}
          refetchData={refetchDepartmentsData}
        />
      </CustomModal>
      <CustomModal
        isModalOpen={isEditModalOpen}
        isShowActionButton= {false}
        handleClose={() => setIsEditModalOpen(false)}
        title={`Edit Department`}
      >
        <AddEntryModal
          onClose={() => setIsEditModalOpen(false)}
          title={`Department`}
          refetchData={refetchDepartmentsData}
          selectedDepartment={selectedDepartment}
          setSelectedDepartment={setSelectedDepartment}
        />
      </CustomModal>
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        disableScrollLock
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            p: "35px 70px",
          }}
        >
          <DialogTitle
            sx={{ p: "0 0 10px !important" }}
          >{`Confirm Delete Department`}</DialogTitle>
          <DialogContent sx={{ p: "0 0 25px" }}>
            Are you sure you want to delete <br />
            <span style={{ fontWeight: "600" }}>
              {" "}
              {selectedDepartment?.name}
            </span>{" "}
            department?
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              gap: "0",
              justifyContent: "center",
              p: "0",
            }}
          >
            <Button
              onClick={() => setIsDeleteModalOpen(false)}
              sx={{ textTransform: "none", color: "#333" }}
            >
              No
            </Button>
            <Button
              onClick={handleDeleteDepartment}
              variant="contained"
              sx={{ textTransform: "none", background: "red" }}
            >
              Yes
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default Departments;
